import styled from 'styled-components';

export const InfoIconBase = styled.div`
  display: flex;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
`;
